import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Typography,
} from "@mui/material";

import "./styles/Status.css";

// dataArray elements:
// email
// group
// id
// lastView
// name
// permission
// role

function StatusProjectTeam(props) {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell
              className="statusProjectTeamHeader"
              colSpan={3}
              sx={{
                backgroundColor: "gainsboro",
                borderRadius: "15px 15px 0px 0px",
                textAlign: "center",
              }}
            >
              <div>Project Team</div>
            </TableCell>
          </TableRow>
          {props.dataArray.map((elem, index) => (
            <TableRow key={index}>
              <TableCell
                className={
                  elem.statusReport == "1"
                    ? "statusProjectTeamCellBold"
                    : "statusProjectTeamCell"
                }
              >
                <div>{elem.name}</div>
              </TableCell>
              <TableCell
                className={
                  elem.statusReport == "1"
                    ? "statusProjectTeamCellBold"
                    : "statusProjectTeamCell"
                }
              >
                <div>{elem.email}</div>
              </TableCell>
              <TableCell
                className={
                  elem.statusReport == "1"
                    ? "statusProjectTeamCellBold"
                    : "statusProjectTeamCell"
                }
              >
                <div>{elem.role}</div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default StatusProjectTeam;

StatusProjectTeam.propTypes = {
  dataArray: PropTypes.array,
};
